import { Box, Stack, Typography } from "@mui/material";
import SubFlowDots from "./SubFlowDots";
import { onboardingTokens } from "../../theme";
import { t } from "../../../../locales/t";

/**
 * The frame every goal sub-flow screen opens with.
 *
 * Three things live here because all of them must hold across five screens and
 * none of them belongs to any one of them:
 *
 *   `data-subflow-goal`, which the test harness reads to know which sub-flow is
 *   on screen. Left to each screen it is five chances to forget one, and the
 *   failure it produces names the harness rather than the screen.
 *
 *   The copy convention: a sub-flow's heading is `onboarding.subflow.<goal>`.
 *
 *   The order — dots, heading, subheading — and the spacing under them.
 *
 * Dumb on purpose: `index` and `total` are threaded in rather than read from
 * context, so this renders from props alone and is testable without a
 * provider. `SubFlowDots` and `GoalCard` are the same.
 *
 * The Continue button is deliberately NOT here — it belongs to the screen,
 * gated on the screen's own answers.
 *
 * @param {object} props
 * @param {string} props.goal
 * @param {number} props.index  zero-based position among the selected goals
 * @param {number} props.total  how many were selected
 * @param {import('react').ReactNode} props.children
 */
const SubFlowHeader = ({ goal, index, total, onSubmit, children }) => (
  <Box
    component="form"
    noValidate
    data-subflow-goal={goal}
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    <SubFlowDots total={total} current={index} />

    <Typography variant="h1" sx={{ mb: 1 }}>
      {t(`onboarding.subflow.${goal}.heading`)}
    </Typography>
    <Typography
      sx={{ color: onboardingTokens.mutedForeground, lineHeight: 1.6, mb: 4 }}
    >
      {t(`onboarding.subflow.${goal}.subheading`)}
    </Typography>

    <Stack gap={4}>{children}</Stack>
  </Box>
);

export default SubFlowHeader;
